<script lang="ts">
import DbcSvg from '../DbcSvg.vue'
export default {
  props: {
    level: Number,
    text: String,
    aos: {
      type: Object,
      required: false,
    },
    category: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const headlineTag = `h${props.level}`
    const isH1orH2 = headlineTag === 'h1' || headlineTag === 'h2'
    const client = useRuntimeConfig().public.client

    if (isWebview() && isH1orH2) return

    const headlinedData = ref<UtilityHeadlineData>({
      class: `font-neo-screen-head dbc-gt-h${props.level} wrap-break-word hyphens-auto`,
    })

    const aosData = ref<{ 'data-aos'?: string; 'data-aos-delay'?: string }>({})

    if (!isWebview()) {
      if (props.aos?.fadeDirection) {
        aosData.value['data-aos'] = props.aos.fadeDirection
      }
      if (props.aos?.delay) {
        aosData.value['data-aos-delay'] = props.aos.delay
      }
    }

    const headlineChildren: any[] = [props.text]

    if ((client === 'cab' || client === 'flinkster') && isH1orH2) {
      const vNodeDbcPulse = h(DbcSvg, {
        name: 'dbc-pulse',
        class: 'flex mt-5 h-[6px] w-[58px]',
      })

      headlineChildren.push(vNodeDbcPulse)
      headlinedData.value.class = `${headlinedData.value.class} `
    }

    if (!props?.category?.text) {
      headlinedData.value = { ...headlinedData.value, ...aosData.value }

      return () => h(headlineTag, headlinedData.value, headlineChildren)
    }

    const wrapperData = { class: 'flex flex-col', ...aosData.value }

    const categoryColorClass = props.category.color
      ? `dbc-text-color-${props.category.color}`
      : ''

    const vnodeCategory = h(
      'p',
      {
        class: `dbc-gt-text-category order-first ${categoryColorClass}`.trim(),
      },
      props.category.text
    )

    return () =>
      h('div', wrapperData, [
        h(headlineTag, headlinedData.value, headlineChildren),
        vnodeCategory,
      ])
  },
}
</script>
